import { useState, useEffect } from 'react';
import DocumentPreview from '../../Create-Investment/documentpreview';
import { useDispatch, useSelector } from 'react-redux';
import { useToast } from '../../../Utils/toastContext';
import { useNavigate } from 'react-router-dom';
import {
  setStepStatus,
  setRejectedFields,
} from '../../../Redux/store/onboardingFormSlice';
import AgreementCard from '../../../Components/onboarding/agreement-card';
import UserQuestionnaire from '../../Risk-Assessment/user-questionnarie';
const ReviewSubmitBusiness = ({ setCurrentStep }) => {
  const dispatch = useDispatch();
  const { showToast } = useToast();
  const roleName = useSelector((state) => state.user.roleName);
  const stepStatus = useSelector((state) => state.form.stepStatus);
  const [dob, setDob] = useState('');
  const [stateId, setStateId] = useState('');
  const [redAddress, setRedAddress] = useState('');
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [applicantCountry, setApplicantCountry] = useState(null);
  const [fileDriverLinsenceFront, setFileDriverLinsenceFront] = useState(null);
  const [fileDriverLinsenceBack, setFileDriverLinsenceBack] = useState(null);
  const [documentNumber, setDocumentNumber] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const navigate = useNavigate();
  const [applicantCountryText, setApplicantCountryText] = useState('');
  const [expiryDate, setExpiryDate] = useState('02/12/2026');
  const [isAllCompleted, setIsAllCompleted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState('John');
  const [lastName, setLastName] = useState('Mayer');
  const [email, setEmail] = useState('mayer@gmail.com');
  const [mobileNumber, setMobileNumber] = useState('+61 6 7898 7298');
  const [fullName, setFullName] = useState('John Mayer');
  const [formerNames, setFormerNames] = useState('John Mayer');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isConfirmWithdraw, setIsConfirmWithdraw] = useState(false);
  const [isConfirmSubmit, setIsConfirmSubmit] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const [collapsedLayers, setCollapsedLayers] = useState({});
  const [layers, setLayers] = useState([]);
  const [agreements, setagreements] = useState([]);
  const [agreedMap, setAgreedMap] = useState([]);
  const [lockedAgreements, setLockedAgreements] = useState({});
  const handleFileClick = (docData) => {
    setcurrentDocument(docData);
    setIsModalOpen(true);
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const EditApplicationAPI = async (sectionId) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/reopen-section?progress_id=${sectionId}`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const withdrawApplicationAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/v1/onboarding/withdraw`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const isAgreementAccepted = (agreement) => {
    return agreement.status === 'AGREED' || agreedMap[agreement.enum] === true;
  };
  const validateAgreementsBeforeNext = () => {
    const missing = agreements
      .map(mapAgreementUI)
      .filter((a) => a.required)
      .filter((a) => !isAgreementAccepted(a));

    return {
      isValid: missing.length === 0,
      missing,
    };
  };

  const mapAgreementUI = (agreement) => {
    return {
      id: agreement.agreement_type.id,
      enum: agreement.agreement_type.enum,
      name: agreement.agreement_type.name,
      description: agreement.agreement_type.description,
      required: agreement.is_required,
      mode: agreement.mode.enum, // UPLOAD_SIGNED | PREVIEW_TICK
      document: agreement.document,
      preview: agreement.preview_document,
      status: agreement.status.enum,
    };
  };

  const getAgreements = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/onboarding/agreements`);

      if (response.status == 200) {
        setagreements(response.data.agreements);
        const agreedMapFromApi = {};
        const lockedMapFromApi = {};

        response.data.agreements.forEach((item) => {
          const enumKey = item.agreement_type.enum;
          const isAccepted = item.status?.enum === 'AGREED' || !!item.agreed_at;

          agreedMapFromApi[enumKey] = isAccepted;
          lockedMapFromApi[enumKey] = isAccepted;
        });

        setAgreedMap(agreedMapFromApi);
        setLockedAgreements(lockedMapFromApi);
        setIsAllCompleted(response.data.all_completed);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
      setIsAllCompleted(false);
    }
  };
  const submitAgreementAPI = async (agreementType) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/agreements/${agreementType}/agree`;
    let bodyData = {
      accepted: true,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleAcceptAgreement = async (checked, agreement) => {
    let toastMessage = null;
    const enumKey = agreement.enum;

    if (lockedAgreements[enumKey]) return; // 🚫 already accepted
    try {
      setLoading(true);
      if (checked) {
        const response = await submitAgreementAPI(agreement.id);
        if (response.status == 200) {
          toastMessage = {
            message: response.message,
            type: 'success',
          };
          getAgreements();
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleWithdraw = async () => {
    let toastMessage = null;
    try {
      const response = await withdrawApplicationAPI();
      if (response.status == 200) {
        setIsConfirmWithdraw(false);
        navigate('/login');
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
      setIsConfirmSubmit(false);
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleEdit = async (sectionId, stepId) => {
    let toastMessage = null;
    try {
      const response = await EditApplicationAPI(sectionId);
      if (response.status == 200) {
        setCurrentStep(stepId);
        const responseStatus = await GetAPIcalls(`/api/v1/onboarding/status`);
        if (responseStatus.status == 200) {
          if (responseStatus.data.length > 0) {
            dispatch(setStepStatus(responseStatus.data));
          }
        }
        const responseRejected = await GetAPIcalls(
          `/api/v1/onboarding/rejected-fields`,
        );
        if (responseRejected.status == 200) {
          dispatch(setRejectedFields(responseRejected.data)); // <-- Save in Redux
        }
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };

  const getDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/onboarding/agent/review-submit/review`,
      );

      if (response.status == 200) {
        //SignUp details
        setFirstName(response.data.open_account_information.first_name);
        setLastName(response.data.open_account_information.last_name);
        setEmail(response.data.open_account_information.email_address);
        setMobileNumber(
          response.data.open_account_information.country_code +
            response.data.open_account_information.mobile_number,
        );
        //Personal information
        setFullName(
          response.data.agent_details.first_name +
            ' ' +
            response.data.agent_details.last_name,
        );
        setFormerNames(response.data.agent_details.former_names);
        const date = new Date(response.data.agent_details.dob);
        const formattedDate = date.toLocaleDateString('en-GB');
        setDob(formattedDate);
        setRedAddress(response.data.agent_details.address.google_address);
        setApplicantCountryText(
          response.data.agent_details.applicant_country.name,
        );
        setApplicantCountry(response.data.agent_details.applicant_country.id);
        //docs
        setExpiryDate(
          response.data.agent_driving_licence?.document_expiry.split('T')[0],
        );
        setDocumentNumber(response.data.agent_driving_licence.document_number);
        setCountryCode(response.data.agent_driving_licence.country_of_issue);
        if (response.data.agent_driving_licence.country_of_issue.id == 14) {
          setStateId(response.data.agent_driving_licence.state_of_issue?.name);
        }
        setFileDriverLinsenceFront(
          response.data.agent_driving_licence.front_file,
        );
        setFileDriverLinsenceBack(
          response.data.agent_driving_licence.back_file,
        );

        setIsDataAvailable(true);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
      setIsDataAvailable(false);
    }
  };
  const submitApplicationAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/${roleName}/review-submit/submit`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleSubmit = async () => {
    let toastMessage = null;
    try {
      const response = await submitApplicationAPI();
      if (response.status == 200) {
        toastMessage = { message: response.message, type: 'success' };
        setIsConfirmSubmit(false);
        const responseStatus = await GetAPIcalls(`/api/v1/onboarding/status`);
        if (responseStatus.status == 200) {
          if (responseStatus.data.length > 0) {
            dispatch(setStepStatus(responseStatus.data));
          }
        }
        const responseRejected = await GetAPIcalls(
          `/api/v1/onboarding/rejected-fields`,
        );
        if (responseRejected.status == 200) {
          dispatch(setRejectedFields(responseRejected.data)); // <-- Save in Redux
        }
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
      setIsConfirmSubmit(false);
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };

  useEffect(() => {
    getDetails();
    getAgreements();
  }, []);
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {stepStatus.length > 0 &&
          (stepStatus[2].status == 'IN_REVIEW' ||
            stepStatus[2].status == 'COMPLETED') && (
            <div className="mb-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
              <img
                src="/warning-circle.svg"
                alt="Info"
                className="w-4 h-4 mr-2"
              />
              <span>
                Your application is{' '}
                <strong>in review by our onboarding team</strong>. You will be
                notified once the verification is complete.{' '}
              </span>
            </div>
          )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className="border-b border-colour-custom pb-2">
            <div className="flex items-center space-x-2 mb-2">
              <img src="/note-2.svg" alt="User Avatar" className="h-6 w-6" />
              <h1 className="text-xl font-medium">
                Review And submit your information
              </h1>
            </div>
          </div>
          {isDataAvailable && (
            <>
              <div className="bg-white border rounded-md p-4 mt-2">
                <div className="flex items-center border-colour-custom space-x-2 px-4">
                  <img
                    src="/profile-circle-black.svg"
                    alt="User Avatar"
                    className="h-6 w-6 mb-2"
                  />
                  <h1 className="text-xl font-medium mb-2">
                    Open Account Information
                  </h1>
                </div>

                <div className="bg-white">
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                    {/* Column 1 */}
                    <div className="flex flex-col px-4 pt-4">
                      <label className="mb-1 text-sm text-labelColour">
                        First Name
                      </label>
                      <span className="break-words max-w-full">
                        {firstName}
                      </span>

                      <label className="mb-1 mt-4 text-sm text-labelColour">
                        Last Name
                      </label>
                      <span className="break-words max-w-full">{lastName}</span>
                    </div>

                    {/* Column 2 */}
                    <div className="flex flex-col mx-4 lg:pt-4 pt-0 sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                      <label className="mb-1 text-sm text-labelColour">
                        Email
                      </label>
                      <span className="break-all whitespace-normal max-w-full">
                        {email}
                      </span>{' '}
                    </div>

                    {/* Column 3 */}
                    <div className="flex flex-col lg:pt-4 pt-0 px-4">
                      <label className="mb-1 text-sm text-labelColour">
                        Mobile Number
                      </label>
                      <span className="break-words max-w-full">
                        {mobileNumber}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white border rounded-md p-4 mt-4">
                <div className="flex justify-between items-start border-colour-custom px-4">
                  {/* Left Section: Icon + Heading */}
                  <div className="flex items-center space-x-2">
                    <img
                      src="/profile-circle-black.svg"
                      alt="User Avatar"
                      className="h-6 w-6"
                    />
                    <h1 className="text-xl font-medium">
                      Personal Information
                    </h1>
                  </div>

                  {/* Right Section: Edit Button */}
                  <img
                    onClick={(e) => {
                      e.preventDefault();
                      handleEdit(stepStatus[0].id, 1);
                    }}
                    src="/edit-details.svg"
                    alt="Edit Icon"
                    className="w-4 h-4 cursor-pointer"
                  />
                </div>
                <div className="bg-white border-b pb-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                    <div className="flex flex-col px-4 pt-4">
                      <label
                        htmlFor="fullName"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Full Name
                      </label>
                      <span>{fullName}</span>
                      <label
                        htmlFor="formerNames"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Customer's Former Name(s)
                      </label>
                      <span>{formerNames}</span>
                    </div>
                    <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                      <label
                        htmlFor="dob"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Date of Birth
                      </label>
                      <span>{dob}</span>
                    </div>
                    <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                      <label
                        htmlFor="redAddress"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Residential Address
                      </label>
                      <span>{redAddress}</span>
                      <label
                        htmlFor="redAddress"
                        className="mb-1 mt-4 text-sm text-labelColour"
                      >
                        Applicant's Country
                      </label>
                      <span>{applicantCountryText}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-white border rounded-md p-4 mt-4">
                <div className="flex justify-between items-start border-colour-custom px-4">
                  {/* Left Section: Icon + Heading */}
                  <div className="flex items-center space-x-2">
                    <img
                      src="/briefcase.svg"
                      alt="User Avatar"
                      className="h-6 w-6"
                    />
                    <h1 className="text-xl font-medium">Upload proof docs</h1>
                  </div>
                  <img
                    onClick={(e) => {
                      e.preventDefault();
                      handleEdit(stepStatus[1].id, 2);
                    }}
                    src="/edit-details.svg"
                    alt="Edit Icon"
                    className="w-4 h-4 cursor-pointer"
                  />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 pt-2">
                  {/* first column */}
                  <div className="flex flex-col pr-4 sm:border-r-0 md:border-r border-gray-300">
                    <div className="flex items-center justify-between">
                      <label
                        htmlFor="investmentType"
                        className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                      >
                        Upload Copy of Driver's License (Front)
                      </label>
                    </div>
                    {fileDriverLinsenceFront && (
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(fileDriverLinsenceFront);
                        }}
                        className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                      >
                        <div className="flex-col flex">
                          <span className="text-black underline">
                            {fileDriverLinsenceFront.file_name}
                          </span>
                        </div>
                      </div>
                    )}
                    <div className="mt-2 flex items-center justify-between">
                      <label
                        htmlFor="investmentType"
                        className="mt-2 text-sm text-labelColour  whitespace-normal break-words block"
                      >
                        Upload Copy of Driver's License (Back)
                      </label>
                    </div>
                    {fileDriverLinsenceBack && (
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(fileDriverLinsenceBack);
                        }}
                        className="cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                      >
                        <div className="flex-col flex">
                          <span className="text-black underline">
                            {fileDriverLinsenceBack.file_name}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                  {/* second column */}
                  <div className="flex flex-col pr-4 sm:border-r-0 md:border-r border-gray-300">
                    <label
                      htmlFor="refId"
                      className="mb-1 text-sm text-labelColour"
                    >
                      Driver's License Number
                    </label>
                    <span>{documentNumber}</span>
                    <div className="mt-2">
                      <label className="block mb-1 w-full text-sm text-[#464646]">
                        Expiry Date
                      </label>
                      <input
                        type="date"
                        value={expiryDate}
                        disabled={true}
                        className="block w-full p-2 text-black font-medium border border-gray-300 rounded-md text-md"
                      />{' '}
                    </div>
                  </div>
                  {/* third column */}
                  <div className="flex flex-col pr-4">
                    <div className="">
                      <div className="flex items-center justify-between">
                        <label
                          htmlFor="investmentType"
                          className="text-sm text-labelColour  whitespace-normal break-words block"
                        >
                          Country where issued
                        </label>
                      </div>
                      <span>{countryCode.name}</span>
                    </div>
                    {countryCode.id == 14 && (
                      <div className="mt-2">
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            State or Territory in Australia
                          </label>
                        </div>
                        <span>{stateId}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {isAllCompleted && (
                <div className="bg-white border rounded-md p-4 mt-4">
                  <div className="flex justify-between items-start border-colour-custom px-4">
                    {/* Left Section: Icon + Heading */}
                    <div className="flex items-center space-x-2">
                      <span
                        className={`material-symbols-outlined ml-2 text-xl transition-all duration-300`}
                      >
                        description
                      </span>
                      <h1 className="text-xl font-medium">Agreements</h1>
                    </div>
                  </div>
                  <div className="mx-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                      {agreements.map(mapAgreementUI).map((agreement) => (
                        <AgreementCard
                          key={agreement.enum}
                          agreement={agreement}
                          agreed={agreedMap[agreement.enum]}
                          isLocked={lockedAgreements[agreement.enum]}
                          onPreview={(e) =>
                            handleFileClick(e, agreement.preview)
                          }
                          setAgreed={(checked) =>
                            handleAcceptAgreement(checked, agreement)
                          }
                        />
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* <div className="bg-white border rounded-md p-4 mt-4">
                <UserQuestionnaire />
                </div> */}
            </>
          )}
        </div>
      </div>
      {stepStatus[2] &&
        stepStatus[2].status !== 'COMPLETED' &&
        stepStatus[2].status !== 'APPROVED' &&
        stepStatus[2].status !== 'IN_REVIEW' && (
          <footer className="bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#375AE7]">
            <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
              {/* Save as Draft */}
              <button
                onClick={() => {
                  setIsConfirmWithdraw(true);
                }}
                className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
              >
                <span>Withdraw Application</span>
              </button>

              <button
                onClick={(e) => {
                  e.preventDefault();
                  if (isAllCompleted) {
                    setLoading(true);
                    handleSubmit();
                  } else {
                    setIsConfirmSubmit(true);
                  }
                }}
                className="flex bg-white w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-black font-medium py-2 px-4 rounded-full text-sm"
              >
                <span>Submit</span>
              </button>
            </div>
          </footer>
        )}
      {isModalOpen && currentDocument && (
        <DocumentPreview
          fileUrl={currentDocument.presigned_url}
          fileName={currentDocument?.file_name || currentDocument?.name}
          onClose={() => setIsModalOpen(false)}
        />
      )}
      {isConfirmWithdraw && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
            <button className="absolute top-3 right-3 text-black text-xl font-bold">
              &times;
            </button>

            <div className="flex justify-center items-center mb-4">
              <div className="flex items-center justify-center">
                <img
                  src="/warning-circle.svg"
                  alt="Add Template Icon"
                  className="h-10 w-10"
                />
              </div>
            </div>

            <h2 className="text-lg font-medium mb-2">
              Are you sure you want to Withdraw Application?
            </h2>
            <p className="text-sm text-black mb-4">
              This will delete all details entered during registration. None of
              the details entered in this form will be saved.
            </p>

            <div className="flex justify-center space-x-4">
              <button
                onClick={() => {
                  setIsConfirmWithdraw(false);
                }}
                className="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
              >
                No
              </button>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setLoading(true);
                  handleWithdraw();
                }}
                className="px-6 py-2 bg-[#375AE7] text-white rounded-full font-medium hover:bg-gray-800"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
      {isConfirmSubmit && (
        <div className="fixed inset-0 z-10 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4">
          <div className="w-full max-w-4xl max-h-[90vh] bg-white rounded-2xl shadow-2xl flex flex-col overflow-hidden">
            {/* HEADER */}
            <div className="flex items-center justify-between px-6 py-4 border-b bg-gradient-to-r from-[#375AE7]/10 to-white">
              <div className="flex items-center gap-3">
                <div className="p-2 rounded-xl bg-[#375AE7]/10 text-[#375AE7]">
                  <span className="material-symbols-outlined text-xl">
                    description
                  </span>
                </div>

                <h1 className="text-lg md:text-xl font-semibold text-slate-800">
                  Agreements
                </h1>
              </div>

              <button
                onClick={() => setIsConfirmSubmit(false)}
                className="text-slate-500 hover:text-red-500 transition"
              >
                <span className="material-symbols-outlined">close</span>
              </button>
            </div>

            {/* BODY */}
            <div className="flex-1 overflow-y-auto px-6 py-5 bg-slate-50">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-5">
                {agreements.map(mapAgreementUI).map((agreement) => (
                  <div
                    key={agreement.enum}
                    className="bg-white rounded-xl shadow-sm border hover:shadow-md transition p-3"
                  >
                    <AgreementCard
                      agreement={agreement}
                      agreed={agreedMap[agreement.enum]}
                      isLocked={lockedAgreements[agreement.enum]}
                      onPreview={(e) => handleFileClick(e, agreement.preview)}
                      setAgreed={(checked) =>
                        handleAcceptAgreement(checked, agreement)
                      }
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* FOOTER */}
            <div className="flex justify-end gap-3 px-6 py-4 border-t bg-white">
              <button
                onClick={() => setIsConfirmSubmit(false)}
                className="px-5 py-2 rounded-xl border border-slate-300 text-slate-700 hover:bg-slate-100 transition"
              >
                Cancel
              </button>

              <button
                onClick={(e) => {
                  e.preventDefault();

                  const { isValid, missing } = validateAgreementsBeforeNext();

                  if (!isValid) {
                    showToast(
                      'Please accept all required agreements. Missing: ' +
                        missing.map((a) => a.name).join(', '),
                      'error',
                    );
                    return;
                  }

                  setLoading(true);
                  handleSubmit();
                }}
                className="px-5 py-2 rounded-xl bg-[#375AE7] text-white font-medium hover:bg-[#2f4bd3] transition shadow-sm"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReviewSubmitBusiness;
